<template>
    <div class="page-title-wrapper">
        <div class="page-title">
            <Avatar class="lg squared float-left"><svgicon :name="avIcon" height="1.5rem"></svgicon></Avatar>
            <!--<div class="avatar lg squared float-left"><svgicon :name="avIcon" height="1.5rem"></svgicon></div>-->
            <div class="page-titles-wrapper float-left">
                <div class="page-main-title">{{mainTitle}}</div>
                <div class="page-sub-title">{{subTitle}}</div>
            </div>
        </div>
        <div class="page-title-actions float-right">
            <slot name="page-title-actions" class="page-title-actions-inner"></slot>
        </div>
    </div>
</template>
<script>
    import Avatar from "../../components/Avatar/Avatar";

    export default {
        name: 'PageTitle',
        components: {
            Avatar
        },
        props: ["mainTitle", "subTitle", "avIcon"],
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./Pagetitle.scss" scoped lang="scss"></style>

